import React from 'react';
import { ChatLinkTarget } from '../../utils/chatLinkCorpus';
import ChatLinkPreviewShell from './ChatLinkPreviewShell';
import FundOpportunityPipelineCard, {
  pipelineToneForInvestorStatus,
} from './ContactAdmin/FundOpportunityPipelineCard';
import InvestmentEntityPipelineCard from './ContactAdmin/InvestmentEntityPipelineCard';

interface ChatLinkTargetPreviewCardProps {
  target: ChatLinkTarget;
  onPreviewNavigate?: () => void;
}

const ChatLinkTargetPreviewCard: React.FC<ChatLinkTargetPreviewCardProps> = ({
  target,
  onPreviewNavigate,
}) => {
  if (target.type === 'fund_investment') {
    const card = target.card;
    const investorStatus = card.investorStatus ?? 'LEAD';

    return (
      <ChatLinkPreviewShell>
        <FundOpportunityPipelineCard
          previewMode
          fundOpportunityId={card.fundOpportunityExternalId ?? ''}
          fundName={card.fundName ?? target.displayName}
          fundSize={card.fundSize}
          tone={pipelineToneForInvestorStatus(investorStatus, card.eoiSubmitted)}
          investorNavigateUrl={target.navigateUrl}
          onPreviewNavigate={onPreviewNavigate}
          investor={
            card.investorExternalId
              ? {
                  id: card.investorExternalId,
                  status: investorStatus,
                  eoiSubmitted: card.eoiSubmitted,
                  indicativeInvestment: card.indicativeInvestment,
                  preferredInvestment: card.preferredInvestment,
                  committedInvestment: card.committedInvestment,
                }
              : undefined
          }
        />
      </ChatLinkPreviewShell>
    );
  }

  return (
    <ChatLinkPreviewShell>
      <InvestmentEntityPipelineCard
        previewMode
        entityId={target.card.entityExternalId ?? target.id.replace(/^entity:/, '')}
        entityName={target.card.entityName ?? target.displayName}
        entityType={target.card.entityTypeCode ?? 'OTHER'}
        entityNavigateUrl={target.navigateUrl}
        onPreviewNavigate={onPreviewNavigate}
      />
    </ChatLinkPreviewShell>
  );
};

export default ChatLinkTargetPreviewCard;
